module.exports = __webpack_public_path__ + "static/scale-model-of-dayton-ohio-7ec715026c365f724d022eaf76bf548d.png";